import $ from 'jquery';
import { trapFocus, removeTrapFocus } from '@shopify/theme-a11y';

export class MiniCart {

  constructor() {
    this.config = {
      selector: '[data-minicart]',
      toggleSelector: '[data-minicart-toggle]',
      removeLineSelector: '[data-remove-line]',
      activeClass: 'mini-cart--active',
    };

    this.triggerElement = null;
    this.onDocumentClickHandler = this._onDocumentClick.bind(this);
    this._onKeydown = (e) => {
      if (e.key === 'Escape') this.close();
    };

    this._init();
  }

  updateMiniCart() {
    $.ajax({
      url: '/cart?view=mini-cart',
      method: 'GET',
      success: (response) => {
        const $response = $(response);
        this.$container.html($response.html());
      },
      error: () => {
        // Silently fail — mini-cart will show stale data until next refresh
      },
    });
  }

  _init() {
    this.$container = $(this.config.selector);
    $(document).on('click', this.config.toggleSelector, this._onClickToggleHandler.bind(this));
    $(document).on('click', this.config.removeLineSelector, this._onClickRemoveHandler.bind(this));
    $(document).on('addedToCart', this.updateMiniCart.bind(this));
  }

  open() {
    if (this.$container.hasClass(this.config.activeClass)) return;

    this.triggerElement = document.activeElement;
    this.$container.addClass(this.config.activeClass);
    $(this.config.toggleSelector).attr('aria-expanded', 'true');
    trapFocus(this.$container[0]);
    document.addEventListener('keydown', this._onKeydown);
    $(document).on('click', this.onDocumentClickHandler);
  }

  close() {
    if (!this.$container.hasClass(this.config.activeClass)) return;

    removeTrapFocus();
    this.$container.removeClass(this.config.activeClass);
    $(this.config.toggleSelector).attr('aria-expanded', 'false');
    document.removeEventListener('keydown', this._onKeydown);
    $(document).off('click', this.onDocumentClickHandler);
    this._returnFocus();
  }

  _returnFocus() {
    if (this.triggerElement && document.body.contains(this.triggerElement)) {
      this.triggerElement.focus();
    } else {
      document.body.focus();
    }
    this.triggerElement = null;
  }

  _onClickToggleHandler(e) {
    e.preventDefault();

    if (this.$container.hasClass(this.config.activeClass)) {
      this.close();
    } else {
      this.open();
    }
  }

  _onDocumentClick(e) {
    if (!$(e.target).closest(this.$container).length) {
      this.close();
    }
  }

  _onClickRemoveHandler(e) {
    e.preventDefault();
    const target = $(e.currentTarget);
    const line = target.data('remove-line');
    target.css({opacity: 0.7});

    $.ajax({
      url: '/cart/change.js',
      method: 'POST',
      data: {
        id: line,
        quantity: 0,
      },
      success: () => {
        const cartLine = $(document).find(`[data-cart-line="${line}"]`);
        const quantity = cartLine.data('quantity');
        const cartCount = $('.cart-link__count');
        const current = parseInt(cartCount.data('count'));
        cartCount
          .data('count', (current - quantity))
          .attr('data-count', (current - quantity))
          .text((current - quantity));

        cartLine.remove();
        this.updateMiniCart();
        if (!$('[data-cart-line]').length) {
          $('[data-cart-empty]').removeClass('hide');
          $('[data-cart-form]').addClass('hide');
        }
      },
      error: () => {
        target.css({opacity: ''});
      },
    });
  }
}
